// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3mzbt","gfeWrapper":"CalendarEvent_gfeWrapper__1z2JB"};